import {checkError} from "root/DataFunctions/ErrorHandlingFunctions";

import $ from "jquery";

export const getDataWithPromise = (url, type, data, suppressErrorCheck = false )  =>
{
    return new Promise((resolve, reject) =>
    {
        if ( url == null || url === '')
        {
            throw Error('getDataWithPromise cannot call an empty URL');
        }
        else
        {
            $.ajax(
                {
                    type: type,
                    url: url,
                    data: data,
                    success: (data) =>
                    {
                        if ( suppressErrorCheck === true )
                        {
                            // Return a silent error if required
                            resolve ( data );
                        }
                        else if (checkError(data))
                        {
                            resolve ( data );
                        }
                    },
                    error: (jqXHR, textStatus, error) =>
                    {
                        reject(jqXHR, textStatus, error);
                    }
                });
        }
    });
}


export const urlExplode = (template, params) =>
{
    let rval = template;

    if ( params !== undefined )
    {
        for (const [key, value] of Object.entries(params))
        {
            rval = rval.replace('{' + key + '}', value);
        }
    }

    return rval;
}

export const appendParams = (start, paramName, value) =>
{
    let returnValue = '';

    if (start === '')
    {
        returnValue = '?' + paramName + '=' + value;
    }
    else
    {
        returnValue = start + '&' + paramName + '=' + value;
    }

    return returnValue;
}

/**
 * Returns a list of parameters formatted for passing as parameters on a URL
 *
 * Can be called with a single string, and array of string valus OR an object of key value pairs:
 *
 * E.g.
 *
 *      const params = getParamList ( 'include-teacher' ) ;
 *
 * or
 *
 *      const params = getParamList ( [ 'include-teacher', 'include-providers' ] ;
 *
 * or
 *
 *      const params = getParamLIst ( { 'include-teacher' : true, max: 12 } ) ;
 *
 * @params {String | Object | Array} flagArray  Array or string objects to be added to the list
 * @params {string} initialJoin ? or & depending on what you want the join character to be
 *
 * @return {String}
 */
export const getParamList = (flagArray, initialJoin = '?') =>
{
    let curJoin = initialJoin === undefined || initialJoin === '?' ? '?' : '&';

    if (typeof flagArray === 'string')
    {
        // If it's just a single string value, just append it
        return curJoin + flagArray ;
    }
    else if (Array.isArray(flagArray))
    {
        // If it's an array, return an array of the names
        return flagArray.reduce((accumulator, currentValue, currentIndex, array) =>
        {
            const add = accumulator + curJoin + currentValue;

            curJoin = '&';

            return add;
        }, '');
    }
    else
    {
        // We can also pass an object if key-values are required

        const keys = Object.keys(flagArray);
        const values = Object.values(flagArray);

        return keys.reduce((accumulator, currentValue, currentIndex, array) =>
        {
            const v = currentValue + '=' + values[currentIndex];

            const add = accumulator + curJoin + v;

            curJoin = '&';

            return add;
        }, '');

    }

}

/**
 * Returns a list of array elements based on a grouped structure of array items
 *
 * for example where a list of records has been retruned from the database and you want to
 * group them as parent - child records base don a key value:
 *
 * E.g.
 *
 *      const params = getParamList ( 'include-teacher' ) ;
 *
 * or
 *
 *      const params = getParamList ( [ 'include-teacher', 'include-providers' ] ;
 *
 * or
 *
 *      const params = getParamLIst ( { 'include-teacher' : true, max: 12 } ) ;
 *
 * @params {Array} data  Array or raw records to be processed
 * @params {string} groupName The name of the groups to be created as a child record ( E.g. 'questions# )
 * @params {string} groupKey The name of the Id field by which the records are to be grouped
 * @params {function} groupFactoryFn The function which will return the top level group record from the data
 * @params {function} memberFactoryFn The function which will return a child item to be added to the group
 *
 * @return {Array}
 */
export const performRecordGrouping = ({data, groupName, groupKey, groupFactoryFn, memberFactoryFn}) =>
{
    const groups = data.reduce((acc, d) =>
    {
        const found = acc.find(a => +a[groupKey] === +d[groupKey]);

        if (found)
        {
            // Push the record into the existing group
            found[groupName].push(memberFactoryFn(d));
        }
        else
        {
            // The group doesn't exist with the given key, so create a new one and push the record as a child
            const value = groupFactoryFn(d, groupName);

            value.questions.push(memberFactoryFn(d));

            acc.push(value);
        }
        return acc;
    }, []);

    return groups;
}
export const getDataFromResponse = (response) =>
{
    if (response === undefined)
    {
        throw new Error("You must pass a parameter to getDataFromResponse()");
    }

    if (response.status !== undefined && response.status != null)
    {
        if ( response.data !== undefined )
        {
            return response.data;
        }
        else
        {
            return [] ;
        }
    }
    else
    {
        return [];
    }
}

export const getAxiosDataFromResponse = (response) =>
{
    if (response === undefined)
    {
        throw new Error("You must pass a parameter to getDataFromResponse()");
    }
    else
    {
        if ( response.data !== undefined && response.data.data !== undefined )
        {
            return getDataFromResponse( response.data ) ;
        }
        else
        {
            console.error ( response ) ;
            throw new Error("Invalid axios response passed to getAxiosDataFromResponse");
        }
    }
}

export const getAxiosCustomDataFromResponse = (response, data_item) =>
{
    if (response === undefined)
    {
        throw new Error("You must pass a parameter to getDataFromResponse()");
    }
    else
    {
        if ( response.data !== undefined && response.data.custom_data !== undefined )
        {
            const custom = response.data.custom_data ;

            return custom ;
        }
        else
        {
            console.error ( response ) ;
            throw new Error("Invalid axios response passed to getAxiosDataFromResponse");
        }
    }
}

export const getCustomDataFromResponse = (response, data_item) =>
{
    if (response === undefined)
    {
        throw new Error("You must pass a parameter to getCustomDataFromResponse()");
    }

    if (response.status !== undefined && response.status != null)
    {
        if (response.custom_data !== undefined)
        {
            if (response.custom_data[data_item] !== undefined)
            {
                return response.custom_data[data_item];
            }
            else
            {
                return [];
            }
        }
        else
        {
            return [];
        }
    }
    else
    {
        return [];
    }
}

export const responseHasCustomData = (response) =>
{
    if (response.custom_data !== undefined && response.custom_data != null)
    {
        return true;
    }
    else
    {
        return false;
    }
}

export const getNamedCustomDataFromResponse = (response, itemName) =>
{
    if (response.status !== undefined && response.status != null)
    {
        if (response.custom_data !== undefined)
        {
            if (response.custom_data[itemName] !== undefined)
            {
                return response.custom_data[itemName];
            }
            else
            {
                return [];
            }
        }
        else
        {
            return [];
        }
    }
    else
    {
        return [];
    }
}
export const getInsertIdFromResponse = (response) =>
{
    if (response.status !== undefined && response.status != null)
    {
        if (response.status.insertId !== undefined)
        {
            return response.status.insertId;
        }
        else
        {
            return null
        }
    }
    else
    {
        return null;
    }
}

export const getEncryptedInsertIdFromResponse = (response) =>
{
    if (response.status !== undefined && response.status != null)
    {
        if (response.status.encInsertId !== undefined)
        {
            return response.status.encInsertId;
        }
        else
        {
            return null
        }
    }
    else
    {
        return null;
    }
}

export const getNumRowsFromResponse = (response) =>
{
    if (response.status !== undefined && response.status != null)
    {
        return +response.status.rowsAffected;
    }
    else
    {
        return 0;
    }
}

export const SUCCESS_STATUS = 'success';
export const FAIL_STATUS = 'fail';

export const getStatusFromResponse = (response) =>
{
    if (response.status !== undefined && response.status != null)
    {
        return response.status;
    }
    else
    {
        return null;
    }
}

export const getResultFromResponse = (response) =>
{
    if (response.status !== undefined && response.status != null)
    {
        return response.status.result;
    }
    else
    {
        return null;
    }
}

export const getErrorDetailromResponse = (response) =>
{
    if (response.status !== undefined && response.status != null)
    {
        return response.status.errorDetail;
    }
    else
    {
        return null;
    }
}

export const getErrorFromResponse = (response) =>
{
    return response.status.error;
}

export const getExceptionClassFromResponse = (response) =>
{
    if (response.status.exceptionClass !== undefined && response.status.exceptionClass != null)
    {
        return response.status.exceptionClass;
    }
    else
    {
        return null;
    }
}

export const getStackTraceFromResponse = (response) =>
{
    if (response.status.errorDetail !== undefined && response.status.errorDetail != null)
    {
        if (response.status.errorDetail.trace !== undefined)
        {
            return response.status.errorDetail.trace;
        }
        else
        {
            return null;
        }
    }
    else
    {
        return null;
    }
}
export const getErrorDetailFromResponse = (response) =>
{
    return response.status.errorDetail;
}

